// extracted by mini-css-extract-plugin
export default {"banner":"certificate_banner__XjpTk","cards":"certificate_cards__JH2Bm","title":"certificate_title__WUGXb"};